module.exports = __webpack_public_path__ + "static/media/arrow_right.396838e8.svg";